import { Tooltip } from '@heroui/react';
import type { ReactNode } from 'react';

export interface CustomTooltipProps {
  readonly children: ReactNode;
  readonly tip: string;
  readonly placement: 'top' | 'right' | 'bottom' | 'left';
  readonly delay?: number | undefined;
  readonly closeDelay?: number;
  readonly isOpen?: boolean;
  readonly triggerClassName?: string;
  readonly presentationalTrigger?: boolean;
  readonly onContentMouseEnter?: () => void;
}

const presentationalTriggerProps: { role: 'presentation'; tabIndex: number } = {
  role: 'presentation',
  tabIndex: -1,
};

export default function CustomTooltip({
  children,
  tip,
  placement,
  delay = 0,
  triggerClassName,
  presentationalTrigger = false,
  onContentMouseEnter,
  ...rootProps
}: CustomTooltipProps) {
  return (
    <Tooltip delay={delay} {...rootProps}>
      <Tooltip.Trigger
        {...(presentationalTrigger ? presentationalTriggerProps : {})}
        {...(triggerClassName ? { className: triggerClassName } : {})}
      >
        {children}
      </Tooltip.Trigger>
      <Tooltip.Content placement={placement} onMouseEnter={onContentMouseEnter}>
        {tip}
      </Tooltip.Content>
    </Tooltip>
  );
}
